import { render } from "./RegisterAccountForm.vue?vue&type=template&id=32cd7c10"
import script from "./RegisterAccountForm.vue?vue&type=script&lang=js"
export * from "./RegisterAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__